/**
 * Region-aware Firebase Cloud Messaging config.
 *
 * US and AU sessions push through different Firebase projects (AU data residency), so
 * the client app, the service worker and the VAPID key must all come from the session's
 * region. Shared by the client composable and the Nitro service worker route.
 */
export type FcmRegion = 'us' | 'au'

export interface FcmClientConfig {
  apiKey?: string
  appId?: string
  authDomain?: string
  projectId?: string
  messagingSenderId?: string
  webPushCertificate?: string
}

export interface FcmPublicConfig {
  firebaseMessaging: FcmClientConfig
  firebaseMessagingAu?: FcmClientConfig
}

export function normalizeFcmRegion(value: unknown): FcmRegion | undefined {
  if (typeof value !== 'string') return undefined
  const region = value.trim().toLowerCase()
  return region === 'au' || region === 'us' ? region : undefined
}

/** AU never falls back to the US project — an empty config keeps FCM off instead. */
export function fcmConfigForRegion(publicConfig: FcmPublicConfig, region: FcmRegion): FcmClientConfig {
  if (region === 'au') return publicConfig.firebaseMessagingAu ?? {}
  return publicConfig.firebaseMessaging
}
